// extracted by mini-css-extract-plugin
export var closeButton = "_gi-2";
export var closeButtonIcon = "_gi-3";
export var lightboxContent = "_gi-1";
export var lightboxOverlay = "_gi-0";